<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <el-form
      :model="detailInfo"
      ref="detailInfo"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane
          :label="$t('message.' + langItem.langCode)"
          v-for="(langItem, index) in detailInfo.langMaps"
          :key="index"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Title
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.title'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <el-input
                      v-model="langItem.title"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> News Date </label>
                <div class="col-sm-10">
                    <el-date-picker
                      v-model="detailInfo.newsDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Schedule Time </label>
                <div class="col-sm-10">
                    <el-date-picker
                      v-model="period"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="to"
                      start-placeholder="Start Time"
                      end-placeholder="End Time"
                    >
                    </el-date-picker>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Apply User Group
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="applyUserGroup"
                      :rules="{
                        required: false, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="detailInfo.applyUserGroup" v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="item in applyObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Description
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMaps.' + index + '.description'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur'
                    }"
                  >
                    <el-input
                      v-model="langItem.description"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group" >
                <label class="col-sm-2 control-label">
                  Status
                </label>
                <div class="col-sm-4">
                  <el-form-item 
                      prop="status"
                      :rules="{
                        required: false, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                    <el-select v-model="detailInfo.status" disabled v-bind:placeholder='$t("message.PleaseSelect")'>
                        <el-option 
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      type="primary"
                      @click="checkEvent()"
                      :disabled="!(!detailInfo.status||detailInfo.status==3||detailInfo.status==4)"
                      v-if="(checkPermission('NEW_LIST_EDIT') &&
                          $route.query.id) ||
                          (checkPermission('NEW_LIST_ADD') &&
                            !$route.query.id)
                      "
                      >Save</el-button>
                    <el-button @click="showWarning()">{{
                      $t("message.Cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      detailInfo: {
        langMaps: [],
        status:0,
        type:"",
        newsDate:"",
        applyUserGroup:0,
      },
      statusObj:[],
      period:[],
      applyObj:[],
    };
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    }
  },
  watch: {
    _language: function() {
      this.setObj();
    },
    detailInfo: {
      handler: function() {
        this.$store.state.edit = true;
      },
      deep: true
    }
  },
  created() {
    var obj = [];
    for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
      obj.push({
        langCode: this.$store.state.userInfo.language[i].langCode,
        title:"",
        description:"",
      });
    }
    this.$set(this.detailInfo, "langMaps", obj);
    this.init();
  },
  mounted() {},
  methods: {
    setObj: function() {
      this.statusObj = [
        {
          value: 0,
          label: "Draft"
        },
        {
          value: 1,
          label: "Pending approval"
        },
        {
          value: 2,
          label: "Pending Publish"
        },
        {
          value: 3,
          label: "Rejected"
        },
        {
          value: 4,
          label: "Suspended"
        },
        {
          value: 5,
          label: "Pending Suspend"
        },
        {
          value: 6,
          label: "Published"
        }
      ];
      this.applyObj = [
        {
          value: 0,
          label: "All User"
        },
        {
          value: 1,
          label: "Active User"
        }
      ];
    },
    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.newsDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data == "000104"){
          this.timeoutEvent();
          return;
        }
        if(data.data.result.startTime){
          this.period = [data.data.result.startTime,data.data.result.endTime]
        }
        if (!data) return;
        this.$set(this, "detailInfo", data.data.result);
        setTimeout(function() {
          that.$store.state.edit = false;
        },500);
      } else {
        setTimeout(function() {
          that.$store.state.edit = false;
        },500);
      }
      this.setObj();
    },
    checkEvent: function() {
      this.$refs["detailInfo"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$toastr.w(this.$i18n.t("message.fillRequired"));
          return false;
        }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
                that.callDelete();
              }
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function() {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false
                });
              }
            }
          ]
        });
      }
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.detailInfo) {
          obj[key] = this.detailInfo[key];
        }
        if(this.period.length){
          obj.startTime = this.period[0];
          obj.endTime = this.period[1];
        }else{
          obj.startTime = "";
          obj.endTime = "";
        }
        var data;
        if (this.$route.query.id) {
          obj.id = this.detailInfo.id;
          obj.apiUrl = this.apiConfig.newsUpdate;
          data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = this.apiConfig.newsCreate;
          data = await this.$store.dispatch("apiEvent", obj);
        }
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.state.edit = false;
          this.$router.go(-1);
        }
      } catch (err) {}
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
    },
  }
};
</script>
